module.exports = __webpack_public_path__ + "img/salad.3804fa86.svg";